const colors = {
  brandYellow: "#E5DB1A",
  brandBlue: "#62C6C1",
  brandConcrete: "#C9C8BA",
  dark: "#0B0B0B",
}

module.exports = colors
